<template>
  <div class="double11 text-NotoSansLight">
    <div class="main w-full">

      <!-- header -->
      <header>
        <div class="container flex justify-between">
          <router-link :to="{ name: 'index' }" class="logo bgLiveABCRed p-5 px-8 cursor-pointer hidden md:block">
            <img src="~@/assets/images/double11_2021/liveabc-logo.png" class="object-contain h-auto w-full max-w-full mx-auto">
          </router-link>
          <router-link :to="{ name: 'index' }" class="logo p-3 px-8 cursor-pointer md:hidden mx-auto block">
            <img src="~@/assets/images/double11_2021/liveabc-logo.png" class="object-contain h-auto w-4/5 max-w-full mx-auto">
          </router-link>
          <div class="text-white items-center tracking-wider hidden md:flex">
            <router-link :to="{ name: 'index' }" class="block p-3">官網首頁</router-link>
            <span class="mx-1">|</span>
            <router-link :to="{ name: 'login' }" class="block p-3">會員登入</router-link>
          </div>
        </div>
      </header>

      <!-- 最強3省 -->
      <section class="banner">
        <div class="container md:px-2 md:pt-8 lg:pt-12">
          <div class="hidden md:flex">
            <div><img src="~@/assets/images/double11_2021/master-image.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <!-- <div><img src="~@/assets/images/double11_2021/title-1.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <div><img src="~@/assets/images/double11_2021/big-mama.png" class="object-contain h-auto w-full max-w-full mx-auto"> </div> -->
          </div>
          <!-- <div class="hidden md:flex -mt-6">
            <div class="w-1/3 px-3"><img src="~@/assets/images/double11_2021/box-1.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <div class="w-1/3 px-3"><img src="~@/assets/images/double11_2021/box-3.png" class="object-contain h-auto w-full max-w-full mx-auto"> </div>
            <div class="w-1/3 px-3"><img src="~@/assets/images/double11_2021/box-2.png" class="object-contain h-auto w-full max-w-full mx-auto"> </div>
          </div> -->

          <div class="md:hidden">
            <img src="~@/assets/images/double11_2021/banner-m.png" class="object-contain h-auto w-full max-w-full mx-auto">
          </div>
        </div>
      </section>
      <!-- links -->
      <section class="links hidden md:block top-0 w-full z-30" :class="{ fixed: isFixed }" ref="links">
        <div class="container">
          <div class="flex justify-between items-center">
            <a class="px-3 py-6 block cursor-pointer w-1/2 md:w-auto" @click="toPackage"><img src="~@/assets/images/double11_2021/menu-bar/menu_01.png" class="object-contain h-4 md:h-10"></a>
            <div class="px-2 py-6"><img src="~@/assets/images/double11_2021/menu-bar/menu_03.png" class="object-contain md:h-10"></div>
            <a class="px-3 py-6 block cursor-pointer w-1/2 md:w-auto" @click="toMag"><img src="~@/assets/images/double11_2021/menu-bar/menu_05.png" class="object-contain h-4 md:h-10"></a>
            <div class="px-2 py-6"><img src="~@/assets/images/double11_2021/menu-bar/menu_03.png" class="object-contain md:h-10"></div>
            <a class="px-3 py-6 block cursor-pointer w-1/2 md:w-auto" @click="price"><img src="~@/assets/images/double11_2021/menu-bar/menu_07.png" class="object-contain h-4 md:h-10"></a>
            <div class="px-2 py-6"><img src="~@/assets/images/double11_2021/menu-bar/menu_03.png" class="object-contain md:h-10"></div>
            <a class="px-3 py-6 block cursor-pointer w-1/2 md:w-auto" @click="note"><img src="~@/assets/images/double11_2021/menu-bar/menu_09.png" class="object-contain h-4 md:h-10"></a>
          </div>
        </div>
      </section>
      <!-- 第一省 -->
      <section class="save1" id="package">
        <div class="container px-2 py-8 lg:py-12">
          <div class="flex px-2 md:px-8">
            <img src="~@/assets/images/double11_2021/mama-1.png" class="object-contain h-auto w-full max-w-full mx-auto">
          </div>
          <div class="flex -mt-2 justify-between px-2">
            <div class="px-1"><img src="~@/assets/images/double11_2021/blud-t1.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <router-link :to="{ name: 'sale', params: { category: 'digital' }, query: { tag: 104 } }" class="px-1 hidden md:block"><img src="~@/assets/images/double11_2021/more.png" class="object-contain h-auto w-full max-w-full mx-auto"> </router-link>
          </div>
          <!-- 套書列表 -->
          <div class="mag-items pink-light p-2 text-gray">
            <ul class="list">
              <li class="flex p-2" v-for="(item, index) in packageList" :key="index">
                <router-link :to="{ name: 'sale', params: { category: 'package' }, query: { tag: 104 } }" class="w-full block overflow-hidden">
                  <div class="p-3 bg-white mb-3 rounded-lg">
                    <div class="outer">
                      <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">

                        <img
                          class="w-full h-full object-contain block"
                          :src="item.img_url"
                        >
                      </div>
                    </div>
                  </div>

                  <div class="item-content p-3 rounded-lg text-white font-semibold">
                    <ul class="font-semibold text-center text-xl md:text-2xl flex md:flex-col justify-center">
                      <li>{{ item.grade }}</li>
                      <li class="md:hidden">&emsp;</li>
                      <li>{{ item.people }}</li>
                    </ul>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
          <router-link :to="{ name: 'sale', params: { category: 'package' }, query: { tag: 104 } }" class="px-1 md:hidden"><img src="~@/assets/images/double11_2021/more-2.png" class="object-contain h-auto w-auto max-w-full mx-auto"> </router-link>
        </div>
      </section>

      <!-- 第二省 -->
      <section class="save2" id="mag">
        <div class="container px-2 py-8 lg:py-12">
          <div class="flex px-2 md:px-8">
            <img src="~@/assets/images/double11_2021/mama-2.png" class="object-contain h-auto w-full max-w-full mx-auto">
          </div>
          <div class="flex -mt-2 mb-4 justify-between px-2">
            <div class="px-1"><img src="~@/assets/images/double11_2021/red-t2.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <router-link :to="{ name: 'sale', params: { category: 'package' }, query: { tag: 105 } }" class="px-1 hidden md:block"><img src="~@/assets/images/double11_2021/more.png" class="object-contain h-auto w-full max-w-full mx-auto"> </router-link>
          </div>
          <!-- 雜誌列表 -->
          <div class="mag-items pink-light p-2 text-gray">
            <ul class="list">
              <li class="flex p-2" v-for="(item, index) in magazine" :key="index">
                <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="w-full block bg-white rounded-lg overflow-hidden">
                  <div class="award py-5">
                    <img :src="item.logo_url" class="object-contain h-auto max-w-full mx-auto">
                  </div>
                  <div class="p-3">
                    <div class="outer">
                      <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 lg:p-5 absolute w-full h-full">

                        <img
                          class="w-full h-full object-contain block"
                          :src="item.img_url"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="item-content p-3">

                    <ul class="font-bold text-center text-2xl">
                      <li>{{ item.grade }}</li>
                      <li>{{ item.people }}</li>
                    </ul>

                  </div>
                </router-link>
              </li>
            </ul>
          </div>

          <router-link :to="{ name: 'sale', params: { category: 'package' }, query: { tag: 105 } }" class="px-1 md:hidden"><img src="~@/assets/images/double11_2021/more-2.png" class="object-contain h-auto w-auto max-w-full mx-auto"> </router-link>
        </div>
      </section>

      <!-- 第三省 -->
      <section class="save3" id="price">
        <div class="container px-2 py-8 lg:py-12">
          <div class="flex px-2 md:px-8">
            <img src="~@/assets/images/double11_2021/mama-3.png" class="object-contain h-auto w-full max-w-full mx-auto">
          </div>
          <div class="flex -mt-2 justify-between px-2">
            <div class="px-1"><img src="~@/assets/images/double11_2021/green-t3.png" class="object-contain h-auto w-full max-w-full mx-auto"></div>
            <router-link :to="{ name: 'sale', params: { category: 'package' }, query: { tag: 106 } }" class="px-1 hidden md:block"><img src="~@/assets/images/double11_2021/more.png" class="object-contain h-auto w-full max-w-full mx-auto"></router-link>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full md:w-1/2 p-4">
              <img src="~@/assets/images/double11_2021/st-1.png" class="object-contain h-auto w-full max-w-full mx-auto">
            </div>
            <div class="w-full md:w-1/2 p-4">
              <img src="~@/assets/images/double11_2021/st-2.png" class="object-contain h-auto w-full max-w-full mx-auto">
            </div>
          </div>
          <div class="mb-8">
            <img src="~@/assets/images/double11_2021/gift-imaes.png" class="object-contain h-auto w-full max-w-full mx-auto">
          </div>

        </div>
      </section>

      <section class="footer" id="note">
        <div class="container px-2 pb-8">
          <div class="text-white px-2 font-semibold tracking-wider">
            <p class="text-2xl md:text-3xl mb-3">注意事項</p>
            <ul class="text-xl md:text-2xl leading-loose list-decimal list-inside">
              <li>抽獎辦法：即日起至2021/11/30止，全館消費金額滿1,111元(含以上)，即符合資格可參加抽獎。</li>
              <li>抽獎公佈日期：2021/12/15 公佈於LiveABC官方網站（https://store.liveabc.com/）。</li>
              <!-- eslint-disable-next-line -->
              <li>中華民國稅法規定，中獎贈品或獎金價值超過市價新台幣1,000元，年度報稅時須計入個人所得，故中獎人於領獎後、所得稅徵收前，將會收到本公司所發出之扣繳憑證。</li>
              <li>中華民國稅法規定，凡贈與獎項金額超過新台幣20,000元，將依法課徵10%所得稅。</li>
              <li>由於中獎獎品之價值會受市場價格波動之影響，因此以中獎通知單內所標明之贈品價值為準。</li>
              <li>本活動之抽獎贈品不得轉換、轉讓或折換現金。</li>
              <li>如提供獎項因故無法取得，本公司保留替換其他等值獎項及變更、修改本活動之權利。</li>
            </ul>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
import jump from 'jump.js'
export default {
  name: 'Double11_2021',
  metaInfo () {
    return {
      title: 'LiveABC｜11.11狂購節 最強3省！',
      titleTemplate: null
    }
  },
  data () {
    return {
      linksOfftop: 0,
      isFixed: false,
      packageList: [
        { name: 'ABC', id: 7246, img_url: require('@/assets/images/double11_2021/book-1.png'), grade: '看CNN專訪學英語', people: '點讀套書' },
        { name: 'LIVE', id: 7248, img_url: require('@/assets/images/double11_2021/book-2.png'), grade: '和全球做生意', people: '點讀套書' },
        { name: 'ALL', id: 7250, img_url: require('@/assets/images/double11_2021/book-3.png'), grade: '去日本生活必備工具書', people: '日語套書' },
        { name: 'CNN', id: 7252, img_url: require('@/assets/images/double11_2021/book-4.png'), grade: '全面備戰多益滿分必看', people: '點讀套書' },
        { name: 'JP', id: 7254, img_url: require('@/assets/images/double11_2021/book-5.png'), grade: '流行英語我最行', people: '點讀套書' },
        { name: 'HW', id: 7340, img_url: require('@/assets/images/double11_2021/book-6.png'), grade: 'ABC英語故事袋', people: '系列套書' }
      ],
      magazine: [
        { name: 'ABC', id: 6968, logo_url: require('@/assets/images/double11_2021/abc-logo.png'), img_url: require('@/assets/images/double11_2021/abc-cover.png'), grade: '初級 / 基礎 / 活用', people: '打好英語基礎的最佳選擇' },
        { name: 'LIVE', id: 6970, logo_url: require('@/assets/images/double11_2021/live-logo.png'), img_url: require('@/assets/images/double11_2021/live-cover.png'), grade: '中級 / 生活 / 實用', people: '日常生活實用英語輕鬆學' },
        { name: 'ALL', id: 6972, logo_url: require('@/assets/images/double11_2021/all-logo.png'), img_url: require('@/assets/images/double11_2021/all-cover.png'), grade: '中高級 / 進階 / 應用', people: '閱讀寫作訓練豐富又多元' },
        { name: 'CNN', id: 6974, logo_url: require('@/assets/images/double11_2021/cnn-logo.png'), img_url: require('@/assets/images/double11_2021/cnn-cover.png'), grade: '新聞 / 時事 / 新知', people: '官方授權的專業新聞素材' },
        { name: 'JP', id: 6976, logo_url: require('@/assets/images/double11_2021/jp-logo.png'), img_url: require('@/assets/images/double11_2021/jp-cover.png'), grade: '初級 / 生活 / 實用', people: '日籍老師主編內容實用到位' },
        { name: 'HW', id: 6978, logo_url: require('@/assets/images/double11_2021/hw-logo.png'), img_url: require('@/assets/images/double11_2021/hw-cover.png'), grade: '科普/ 圖像 / 百科', people: '全家大小都看得懂的科普雜誌' }
      ]
    }
  },
  mounted () {
    window.addEventListener('scroll', this.stickyLinks)
  },
  destroyed () {
    window.addEventListener('scroll', this.stickyLinks)
  },
  methods: {
    toPackage () {
      jump('#package', {
        duration: 500,
        offset: 0
      })
    },
    toMag () {
      jump('#mag', {
        duration: 800,
        offset: 0
      })
    },
    price () {
      jump('#price', {
        duration: 900,
        offset: 0
      })
    },
    note () {
      jump('#note', {
        duration: 1000,
        offset: 0
      })
    },

    stickyLinks () {
      let self = this

      let linkOffset = self.$refs.links.offsetTop
      // eslint-disable-next-line no-unused-expressions
      linkOffset > 0 ? self.linksOfftop = linkOffset : null

      window.pageYOffset > self.linksOfftop ? self.isFixed = true : self.isFixed = false
    }
  }
}
</script>
<style lang="scss" scoped>
.double11 {
  header {
    background: #313131;
  }
  .banner {
    background-image: url('~@/assets/images/double11_2021/dot.png'), url('~@/assets/images/double11_2021/dot.png'), url('~@/assets/images/double11_2021/pink-bg.png');
    background-repeat: no-repeat, no-repeat, repeat;
    background-position: top left, bottom right, right;
  }
  .links {
    background-repeat: repeat;
    background-origin: padding-box;
    background-image: url('~@/assets/images/double11_2021/orange-bg.png');

  }
  .save1 {
    background-repeat: repeat;
    background-origin: padding-box;
    background-image: url('~@/assets/images/double11_2021/green-bg.png');
    .item-content {
      background: #186AC4;
    }
  }
  .save2 {
    background-repeat: repeat;
    background-origin: padding-box;
    background-image: url('~@/assets/images/double11_2021/blue-bg.png');
    .item-content ul {
      color: #313131;
    }
  }
  .save3 {
    background-repeat: repeat;
    background-origin: padding-box;
    background-image: url('~@/assets/images/double11_2021/red-bg.png');
  }
  .footer {
    background-repeat: repeat;
    background-origin: padding-box;
    background-image: url('~@/assets/images/double11_2021/red-bg.png');
  }

  .outer {
    position: relative;
    width: 100%;
    background:white;
    display: block;
    &:after {
      content: "";
      display: block;
      padding-bottom: 100%;
    }
    .inner {
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .mag-items {
    .list {
      display: grid;
      overflow: hidden;
      grid-template-columns: repeat(3, 1fr);
      grid-auto-rows: 1fr;
      grid-column-gap: 5px;
      grid-row-gap: 5px;
      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }
      @media (max-width: 640px) {
        grid-template-columns: repeat(1, 1fr);
      }
      .award {
        background: #00C6A0;
      }

      .textCenter {
        text-align: center;
      }
    }
  }
}
</style>
